import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import { ANNUAL_PRICE } from '../../config/constants';
import calculatorSvg from '../../images/icons/calculator.svg';
import { cta, ctaSm, paddingXs, ctaRow, imgLeft, subHeading } from './cta.module.scss';

const CtaBusinessSm0 = ({ primaryEventId }) => {
    return (
        <Link
            to="/"
            className={`${cta} ${ctaSm} ${paddingXs} icon-animate-bounce`}
            id={primaryEventId}
            style={ { background: '#ecfeff' } }>
            <div className={`justify-center align-center ${ctaRow}`}>
                <img
                    src={calculatorSvg}
                    className={imgLeft}
                    width="80"
                    alt="Payroll calculator"
                    role="presentation"
                />
                <div>
                    <p className={`${subHeading}`}>
                        <span>
                            Need to calculate <strong>employer taxes</strong>?  Run payroll for an affordable price of ${ANNUAL_PRICE}/year. All features are free during a 14-day trial.
                        </span>
                    </p>
                </div>
            </div>
        </Link>
    );
};

CtaBusinessSm0.propTypes = {
    primaryEventId: PropTypes.string.isRequired,
};

export default CtaBusinessSm0;
